import React, { useEffect, useRef } from "react";
import styles from "../components/comp_css/chapter_18.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from 'next/router';
import Common_html from "./Common_html";
import BlockData from "../../../central-doctraine-json/chapter18.json";

function Chapter_18() {
  // const corosalref = useRef()

  // useEffect(() => {
  //     if (corosalref.current) {
  //         corosalref.current.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //             inline: "start"
  //         })
  //     }
  //     console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter()
  const location = useRouter();
  const { pathname } = location;



  return (
    <>
      <Head>
        <title>The evolution Will | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-XVIII"
        ></meta>
        <meta
          property="og:title"
          content="The evolution Will | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter18_OG_image_18_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Abstract representation of the concept of 'The Evolution Will,' blending divine and cosmic symbols with elements of growth and transformation."></meta>
        <meta
          property="og:description"
          content="Volution is the will of an individual at a primal level. Read more from here."
        ></meta>

        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=18"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter18_OG_image_18_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Abstract representation of the concept of 'The Evolution Will,' blending divine and cosmic symbols with elements of growth and transformation."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=18"></meta>
        <meta name="twitter:title" content="The evolution Will | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="Volution is the will of an individual at a primal level. Read more from here."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=18" />
      </Head>


      <Common_html BlockData={BlockData} />
    </>
  );
}

export default Chapter_18;
